export default {
  // Basic info
  'agents.title': 'Agents',
  'agents.tab.ai': 'AI',
  'agents.tab.rpa': 'RPA',
  'agents.tab.skills': 'Skills',

  // AI Provider options (for filters and forms)
  'agents.ai.provider.openai': 'OpenAI',

  // RPA Platform options (for filters and forms)
  'agents.rpa.platform.windows': 'Windows',
  'agents.rpa.platform.android': 'Android',

  // RPA Status options (for filters and forms)
  'agents.rpa.status.unknown': 'Unknown',
  'agents.rpa.status.online': 'Online',
  'agents.rpa.status.offline': 'Offline',
  'agents.rpa.status.disabled': 'Disabled',

  // Buttons
  'agents.button.interact': 'Interact',
  'agents.button.builder': 'Builder',

  'agents.text.ownerUser': 'Owner',

  // Form field translations
  'agents.form.provider': 'Provider',
  'agents.form.publisher': 'Publisher',
  'agents.form.model': 'Model',
  'agents.form.connections': 'Connections',
  'agents.form.connections.connection': 'Connection',
  'agents.form.allowedRoles': 'Role Configuration',
  'agents.form.allowedRoles.allowed': 'Allowed Roles',
  'agents.form.allowedRoles.denied': 'Denied Roles',
  'agents.form.memory': 'Memory',
  'agents.form.team': 'Team',
  'agents.form.platform': 'Platform',
  'agents.form.name': 'Name',
  'agents.form.email': 'Email',
  'agents.form.username': 'Username',
  'agents.form.domains': 'Domains',
  'agents.form.description': 'Description',
  'agents.form.longDescription': 'Long Description',
  'agents.form.instructions': 'Instructions',
  'agents.form.instructions.edit': 'Edit Instructions',
  'agents.form.instructions.placeholder.expanded':
    'Write detailed instructions for your AI agent...',
  'agents.form.icon': 'Icon',
  'agents.form.isActive': 'Active',
  'agents.form.status': 'Status',
  'agents.form.deviceName': 'Device Name',
  'agents.form.ip': 'IP Address',
  'agents.form.ip.error': 'Please enter a valid IP address',
  'agents.form.skills': 'Skills',
  'agents.form.skills.skill': 'Skill',
  'agents.form.collaborators.collaborator': 'Collaborator',

  // Access Control (replaces deprecated collaborators in the versioned config)
  'agents.form.accessControl.filtersLogicalOperator': 'Operator between sections',
  'agents.form.accessControl.userGroupsFiltersLogicalOperator':
    'Operator between groups and other sections',
  'agents.form.accessControl.users': 'Allowed users',
  'agents.form.accessControl.userGroups': 'Allowed user groups',
  'agents.form.accessControl.positions': 'Allowed positions',
  'agents.form.accessControl.areas': 'Allowed areas',
  'global.logicalOperator.and': 'AND (all must match)',
  'global.logicalOperator.or': 'OR (at least one)',

  // Configuration translations
  'agents.form.configurations.greetings': 'Greetings',
  'agents.form.configurations.greetings.message': 'Message',
  'agents.form.configurations.greetings.message.edit': 'Edit Greeting Message',
  'agents.form.configurations.greetings.message.placeholder':
    'Write the greeting message for this language...',
  'agents.form.configurations.searchingHumanAgentMessages': 'Searching Human Agent Messages',
  'agents.form.configurations.searchingHumanAgentMessages.message': 'Message',
  'agents.form.configurations.searchingHumanAgentMessages.message.edit': 'Edit Search Message',
  'agents.form.configurations.searchingHumanAgentMessages.message.placeholder':
    'Write the human agent search message for this language...',
  'agents.form.configurations.trainingVectors': 'Training Vectors',
  'agents.form.configurations.reasoningEffort': 'Reasoning Effort',
  'agents.form.configurations.reasoningEffort.none': 'None',
  'agents.form.configurations.reasoningEffort.minimal': 'Minimal',
  'agents.form.configurations.reasoningEffort.low': 'Low',
  'agents.form.configurations.reasoningEffort.medium': 'Medium',
  'agents.form.configurations.reasoningEffort.high': 'High',
  'agents.form.configurations.reasoningSummary': 'Reasoning Summary',
  'agents.form.configurations.reasoningSummary.concise': 'Concise',
  'agents.form.configurations.reasoningSummary.detailed': 'Detailed',
  'agents.form.configurations.reasoningSummary.auto': 'Auto',
  'agents.form.configurations.allowedTools': 'Allowed Tools',
  'agents.form.configurations.allowedTools.codeinterpreter': 'Code Interpreter',
  'agents.form.configurations.allowedTools.codeinterpreter.description':
    'Runs Python code in a sandbox for computations, data analysis and chart generation.',
  'agents.form.configurations.allowedTools.filesearch': 'File Search',
  'agents.form.configurations.allowedTools.filesearch.description':
    'Queries and retrieves information from files attached to the agent.',
  'agents.form.configurations.allowedTools.websearch': 'Web Search',
  'agents.form.configurations.allowedTools.websearch.description':
    'Searches the Internet for up-to-date information so the agent can answer with real-time data.',
  'agents.form.configurations.allowedTools.imagegeneration': 'Image Generation',
  'agents.form.configurations.allowedTools.imagegeneration.description':
    'Generates images from natural-language descriptions.',
  'agents.form.configurations.allowedTools.mcp': 'MCP',
  'agents.form.configurations.allowedTools.mcp.description':
    'Connects the agent to external MCP servers for remote tools and data sources.',
  'agents.form.configurations.allowedTools.function': 'Function',
  'agents.form.configurations.allowedTools.function.description':
    'Lets the agent invoke custom functions declared by the system.',
  'agents.form.configurations.allowedTools.shell': 'Shell',
  'agents.form.configurations.allowedTools.shell.description':
    'Executes terminal commands in a sandboxed environment to automate system tasks.',
  'agents.form.configurations.allowedTools.automyinternalmcp': 'Internal MCP',
  'agents.form.configurations.allowedTools.automyinternalmcp.description':
    "Enables Automy's built-in tools: processes, lists, entities and platform actions.",
  'agents.form.configurations.allowedTools.automyinternalfunctionaitodo': 'Plan ToDo',
  'agents.form.configurations.allowedTools.automyinternalfunctionaitodo.description':
    'Lets the agent create task ToDos to plan and track long-running operations by breaking them into steps.',
  'agents.form.configurations.guardrails.title': 'Guardrails',
  'agents.form.configurations.guardrails.moderation.enabled': 'Moderation Options Enabled',
  'agents.form.configurations.guardrails.pii.enabled': 'PII Options Enabled',
  'agents.form.configurations.guardrails.pii.rules': 'PII Rules',
  'agents.form.configurations.guardrails.pii.rules.entity': 'Entity',
  'agents.form.configurations.guardrails.pii.rules.entity.creditcard': 'Credit Card',
  'agents.form.configurations.guardrails.pii.rules.entity.email': 'Email',
  'agents.form.configurations.guardrails.pii.rules.entity.phone': 'Phone',
  'agents.form.configurations.guardrails.pii.rules.entity.ipaddress': 'IP Address',
  'agents.form.configurations.guardrails.pii.rules.entity.ibancode': 'IBAN Code',
  'agents.form.configurations.guardrails.pii.rules.entity.url': 'URL',
  'agents.form.configurations.guardrails.pii.rules.entity.usbanknumber': 'US Bank Number',
  'agents.form.configurations.guardrails.pii.rules.entity.usitin': 'US ITIN',
  'agents.form.configurations.guardrails.pii.rules.entity.uspassport': 'US Passport',
  'agents.form.configurations.guardrails.pii.rules.entity.usssn': 'US SSN',
  'agents.form.configurations.guardrails.pii.rules.entity.pedni': 'PE DNI',
  'agents.form.configurations.guardrails.pii.rules.entity.peruc': 'PE RUC',
  'agents.form.configurations.guardrails.pii.rules.entity.pepassport': 'PE Passport',
  'agents.form.configurations.guardrails.pii.rules.entity.pebankaccountnumber':
    'PE Bank Account Number',
  'agents.form.configurations.guardrails.pii.rules.entity.pebankaccountcci': 'PE Bank Account CCI',
  'agents.form.configurations.guardrails.pii.rules.action': 'Action',
  'agents.form.configurations.guardrails.pii.rules.action.mask': 'Mask',
  'agents.form.configurations.guardrails.pii.rules.action.pseudonymize': 'Pseudonymize',
  'agents.form.configurations.guardrails.pii.rules.action.tokenizereversible':
    'Tokenize Reversible',
  'agents.form.configurations.guardrails.pii.rules.action.remove': 'Remove',
  'agents.form.configurations.guardrails.pii.rules.action.keep': 'Keep',
  'agents.form.configurations.guardrails.pii.rules.maskChar': 'Mask Character',
  'agents.form.configurations.guardrails.pii.rules.keepPrefix': 'Keep Prefix',
  'agents.form.configurations.guardrails.pii.rules.keepSuffix': 'Keep Suffix',
  'agents.form.configurations.guardrails.urlFilter.enabled': 'URL Filter Options Enabled',
  'agents.form.configurations.guardrails.urlFilter.action': 'Action',
  'agents.form.configurations.guardrails.urlFilter.action.block': 'Block',
  'agents.form.configurations.guardrails.urlFilter.action.mask': 'Mask',
  'agents.form.configurations.guardrails.urlFilter.action.warn': 'Warn',
  'agents.form.configurations.guardrails.urlFilter.mode': 'Mode',
  'agents.form.configurations.guardrails.urlFilter.mode.allowlist': 'Allow List',
  'agents.form.configurations.guardrails.urlFilter.mode.denylist': 'Deny List',
  'agents.form.configurations.guardrails.urlFilter.allowedDomains': 'Allowed Domains',
  'agents.form.configurations.guardrails.urlFilter.blockedDomains': 'Blocked Domains',
  'agents.form.configurations.guardrails.urlFilter.blockedRegex': 'Blocked Patterns (Regex)',
  'agents.form.configurations.guardrails.urlFilter.domain': 'Domain',
  'agents.form.configurations.guardrails.urlFilter.pattern': 'Pattern',
  'agents.form.configurations.guardrails.urlFilter.allowIpHosts': 'Allow IP Hosts',
  'agents.form.configurations.guardrails.urlFilter.allowedSchemes': 'Allowed Schemes',
  'agents.form.configurations.guardrails.urlFilter.scheme': 'Scheme',
  'agents.form.configurations.guardrails.urlFilter.maxUrls': 'Max URLs',
  'agents.form.configurations.guardrails.urlFilter.blockUrlShorteners': 'Block URL Shorteners',
  'agents.form.configurations.guardrails.urlFilter.urlShortenerDomains': 'URL Shortener Domains',
  'agents.form.configurations.guardrails.jailbreak.enabled': 'Jailbreak Options Enabled',
  'agents.form.configurations.guardrails.jailbreak.model': 'Model',
  'agents.form.configurations.guardrails.jailbreak.blockConfidence': 'Block Confidence',

  // Tabs
  'agents.tabs.general': 'General',
  'agents.tabs.configurations': 'Configurations',

  // Wizard steps
  'agents.wizard.steps.basicInformation': 'Basic Information',
  'agents.wizard.steps.technicalConfiguration': 'Technical Configuration',
  'agents.wizard.steps.permissions': 'Permissions',
  'agents.wizard.steps.accessControl': 'Access Control',
  'agents.wizard.steps.advancedConfigurationAndContent': 'Advanced Configuration and Content',
  'agents.wizard.steps.guardrails': 'Guardrails',

  // Global translations
  'global.text.configuration': 'Configuration',

  // Agent Builder
  'agentBuilder.title': 'New agent',
  'agentBuilder.sidebar.overview': 'Overview',
  'agentBuilder.token.error.title': 'Versioned configuration unavailable',
  'agentBuilder.token.error.description':
    'Could not issue an edit token for this version. Changes to instructions, skills, connections, permissions, access control, greetings, training vectors and guardrails won\u2019t be saved until the connection recovers. Basic agent metadata (name, model, description) can still be edited.',
  'agentBuilder.panel.saving': 'Saving…',
  'agentBuilder.header.openChat': 'Open chat',
  'agentBuilder.chat.title': 'AI Assistant',
  'agentBuilder.chat.open': 'Open chat',
  'agentBuilder.chat.close': 'Close chat',
  'agentBuilder.error.notFound': 'The requested agent could not be loaded.',
  'agentBuilder.unsaved.indicator': 'Unsaved changes',
  'agentBuilder.unsaved.confirm':
    'You have unsaved changes. Are you sure you want to leave and discard them?',
  'agentBuilder.save.error': 'Unable to save the agent changes.',
  'agentBuilder.card.unnamed': 'Unnamed agent',
  'agentBuilder.card.noModel': 'No model',
  'agentBuilder.card.restricted': 'Restricted',
  'agentBuilder.card.itemsCount': '{count, plural, =0 {No items} one {# item} other {# items}}',
  'agentBuilder.newAgent.title': 'New AI agent',
  'agentBuilder.newAgent.subtitle': 'Set the basic identity. Complete the rest in the builder.',
  'agentBuilder.newAgent.continue': 'Continue',
  'agentBuilder.newAgent.name.placeholder': 'e.g. Sales assistant',
  'agentBuilder.newAgent.email.placeholder': 'sales@agent.automy.global',
  'agentBuilder.newAgent.description.placeholder': 'What does this agent do? Who does it help?',
  'agentBuilder.card.active': 'Active',
  'agentBuilder.card.inactive': 'Inactive',
  'agentBuilder.card.public': 'Public',
  'agentBuilder.card.private': 'Private',
  'agentBuilder.card.configure': 'Configure',
  'agentBuilder.card.empty': 'Not configured',
  'agentBuilder.card.configured': 'Configured',
  'agentBuilder.card.stats.permissions':
    '{count, plural, =0 {No permissions} one {# permission} other {# permissions}}',
  'agentBuilder.card.stats.greetings':
    '{count, plural, =0 {No greetings} one {# greeting} other {# greetings}}',
  'agentBuilder.card.stats.guardrails':
    '{count, plural, =0 {No guardrails} one {# active guardrail} other {# active guardrails}}',
  'agentBuilder.card.stats.skills':
    '{count, plural, =0 {No skills} one {# skill} other {# skills}}',
  'agentBuilder.card.stats.connections':
    '{count, plural, =0 {No connections} one {# connection} other {# connections}}',
  'agentBuilder.card.stats.escalations':
    '{count, plural, =0 {No escalations} one {# escalation} other {# escalations}}',
  'agentBuilder.card.stats.guardrailsRatio': '{active}/{total} active',
  'agentBuilder.card.noDescription': 'Add a description so your team knows how to use this agent.',
  'agentBuilder.section.general': 'General',
  'agentBuilder.section.brain': 'Brain',
  'agentBuilder.section.brain.subtitle':
    "Define the agent's core intelligence: instructions, knowledge and tools it uses to reason.",
  'agentBuilder.card.reasoning.summary.placeholder': 'No summary',
  'agentBuilder.card.reasoning.effort.short': 'Effort',
  'agentBuilder.card.reasoning.summary.short': 'Summary',
  'agentBuilder.section.permissions': 'Permissions',
  'agentBuilder.section.accessControl': 'Access Control',
  'agentBuilder.section.behavior': 'Behavior',
  'agentBuilder.section.guardrails': 'Guardrails',
  'agentBuilder.card.trainingDocs': 'Training documents',
  'agentBuilder.card.stats.trainingDocs':
    '{count, plural, =0 {No documents} one {# document} other {# documents}}',

  // Versions & publish (versioned config flow)
  'agentBuilder.version.createdBy': 'Created by',
  'agentBuilder.version.createdDate': 'Created on',
  'agentBuilder.version.publishedBy': 'Published by',
  'agentBuilder.version.publishedDate': 'Published on',
  'agentBuilder.version.current': 'current',
  'agentBuilder.version.error': 'Could not switch to the selected version.',
  'agentBuilder.publish': 'Publish',
  'agentBuilder.published': 'Published',
  'agentBuilder.publish.success': 'Version published successfully.',
  'agentBuilder.publish.error': 'Could not publish this version.',
  'agentBuilder.publish.forceButton': 'Publish anyway',
  'agentBuilder.publish.inconsistencies.title': 'Review warnings before publishing',
  'agentBuilder.publish.inconsistencies.intro':
    'The agent can be published, but the internal summary detected issues that may affect how tools and resources are routed in chat.',
  'agentBuilder.publish.inconsistencies.hint':
    'If you publish anyway, the orchestrator may route tools or resources sub-optimally until you fix the configuration and publish again.',
  'agentBuilder.publish.tooltip.readOnly':
    'This version is already published. Switch to a draft version to edit.',
  'agentBuilder.readonly.banner':
    'You are viewing a published version in read-only mode. Switch to a draft to edit.',
  'agentBuilder.readonly.cantEdit': 'Cannot edit a published version.',
  'agentBuilder.card.accessControl.public': 'Visible to everyone',
  'agentBuilder.card.accessControl.restricted':
    '{count, plural, =0 {No access configured} one {Restricted access (# entity)} other {Restricted access (# entities)}}',

  // Sidebar entries
  'agentBuilder.sidebar.traces': 'Traces',
  'agentBuilder.sidebar.dependencies': 'Dependencies',

  // Traces
  'agentBuilder.traces.title': 'Configuration traces',
  'agentBuilder.traces.empty': 'No traces yet for this version.',
  'agentBuilder.traces.column.operation': 'Operation',
  'agentBuilder.traces.column.elementType': 'Element',
  'agentBuilder.traces.column.creator': 'User',
  'agentBuilder.traces.column.created': 'Date',
  'agentBuilder.traces.column.data': 'Detail',
  'agentBuilder.traces.operation.generate-token-readonly': 'Read token',
  'agentBuilder.traces.operation.generate-token-write': 'Write token',
  'agentBuilder.traces.operation.append-component': 'Append component',
  'agentBuilder.traces.operation.modify-component': 'Modify component',
  'agentBuilder.traces.operation.remove-component': 'Remove component',
  'agentBuilder.traces.operation.publish': 'Publish',
  'agentBuilder.traces.operation.new-version-created': 'New version',
  'agentBuilder.traces.operation.change-current-version': 'Change current version',

  // Dependencies
  'agentBuilder.dependencies.title': 'Dependencies',
  'agentBuilder.dependencies.empty':
    'This agent has no declared dependencies in the current configuration.',
  'agentBuilder.dependencies.column.entity': 'Entity',
  'agentBuilder.dependencies.column.type': 'Type',
  'agentBuilder.dependencies.column.name': 'Name',

  // EntitySelector keys live in src/locales/{lang}/component.js (shared globally)
};
